import React, { useEffect, useState } from 'react';
import LanguageManager from '../lang/LanguageManager';
import LangStorageManager from '../lang/LangStorageManager';
import '../components/header.css';

export default function Header() {
  const [language, setLanguage] = useState(() => {
    const storage = new LangStorageManager(null);
    return storage.getStorage();
  });
  const [texts, setTexts] = useState(null);

  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "el", label: "Ελληνικά" },
    { code: "nl", label: "Nederlands" },
    { code: "da", label: "Dansk" },
    { code: "no", label: "Norsk" },
    { code: "fi", label: "Suomi" },
    { code: "cs", label: "Čeština" },
    { code: "sk", label: "Slovenčina" },
    { code: "ro", label: "Română" },
    { code: "vi", label: "Tiếng Việt" },
    { code: "id", label: "Bahasa Indonesia" },
    { code: "ms", label: "Bahasa Melayu" },
    { code: "bn", label: "বাংলা" },
    { code: "ptBr", label: "Português (Brasil)" },
    { code: "ptPt", label: "Português (Portugal)" },
    { code: "zh", label: "中文" },
    { code: "af", label: "Afrikaans" },
    { code: "ja", label: "日本語" },
    { code: "ar", label: "العربية" },
    { code: "fr", label: "Français" },
    { code: "it", label: "Italiano" },
    { code: "ko", label: "한국어" },
    { code: "koKp", label: "조선말" },
    { code: "ca", label: "Català" },
    { code: "ru", label: "Русский" },
    { code: "pl", label: "Polski" },
    { code: "de", label: "Deutsch" },
    { code: "hi", label: "हिन्दी" },
    { code: "hu", label: "Magyar" },
    { code: "tr", label: "Türkçe" },
    { code: "ma", label: "الدارجة المغربية" },
    { code: "gl", label: "Galego" },
    { code: "fil", label: "Filipino" },
    { code: "eo", label: "Esperanto" },
    { code: "he", label: "עברית" },
    { code: "ga", label: "Gaeilge" },
    { code: "ne", label: "नेपाली" },
    { code: "sv", label: "Svenska" },
    { code: "uk", label: "Українська" },
    { code: "th", label: "ไทย" },
    { code: "sl", label: "Slovenščina" },
  ];

  useEffect(() => {
    const loadText = async () => {                                        
      const translator = new LanguageManager(language);
      await translator.loadTranslation();
      setTexts(translator.getAll());
    };
    loadText();
  }, [language]);

  function handleLanguage(e) {
    setLanguage(e.target.value);
    const storage = new LangStorageManager(e.target.value);
    storage.setStorage();
    window.location.reload();
  }

  return (
    <header>
      <h2>{texts?.title?.main || 'Portfolio'}</h2>

      <button className="menu-toggle" onClick={toggleMenu}>
        <img src={menuOpen ? "/img/close.png" : "/img/menu.png"} alt="Toggle menu" />
      </button>

      <div className={`lang-nav ${menuOpen ? 'open' : ''}`}>
        <img src="/img/language.png" alt="Language" />
        <select onChange={handleLanguage} value={language}>
          {languages.map(({ code, label }) => (
            <option key={code} value={code}>{label}</option>
          ))}
        </select>

        <nav>
          <a href="#about-me">{texts?.header?.aboutMe || 'About me'}</a>
          <a href="#skills">{texts?.header?.skills || 'Skills'}</a>
          <a href="#projects">{texts?.header?.projects || 'Projects'}</a>
          <a href="#contact">{texts?.header?.contact || 'Contact me'}</a>
        </nav>
      </div>
    </header>
  );
}